<script>
// import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PlainTable from '@components/plainTable'
import { BOverlay } from 'bootstrap-vue'
import {
  reportListMethod,
  reportComputed,
  categoryComputed,
  categoryListMethod,
} from '@state/helpers'
import { ErrorWrapper } from '@utils/error-handler'
import formatDate from '@utils/format-date'
export default {
  page: {
    title: 'Dynamic Report',
  },
  components: {
    Layout,
    PlainTable,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      type: null,
      error: null,
      reportRequest: false,
      isChangeError: false,
      isSuccess: false,
      successMessage: null,
      prevent: null,
      isReportError: false,
      reportError: false,
      reportSuccess: '',
      isLoading: false,
      subcategories: [],
      fields: [],
      viewfields: [],
      reportFields: [],
      reportFieldsName: {},
      tables: [],
      tables1: [],
      days: '',
      category: null,
      showerror: false,
      isreportgenerated: false,
      dynamicReportData: [],
      downloadReportData: [],
    }
  },
  computed: {},
  mounted() {
    this.getReportTable()
    this.fetchCategoryList()
    this.fetchAllSubCategoryList()
  },
  methods: {
    ...reportListMethod,
    ...reportComputed,
    ...categoryListMethod,
    ...categoryComputed,
    dynamicReport() {
      this.isLoading = true
      if (this.fields.length === 0) {
        this.showerror = true
        this.isLoading = false
      } else {
        this.showerror = false
      }
      this.getFields()
      if (this.fields.includes('totalview')) {
        if (this.type === 'Event') {
          this.fields.push({ days: this.days })
          this.viewfields.push({
            key: 'totalview',
            label: 'Total Event Views',
          })
          this.reportFieldsName['Total Event Views'] = 'totalview'
        } else {
          this.fields.push({ days: this.days })
          this.viewfields.push({
            key: 'totalview',
            label: 'Total Course Views',
          })
          this.reportFieldsName['Total Course Views'] = 'totalview'
        }
      } else if (this.fields.includes('logincount')) {
        this.fields.push({ days: this.days })
        this.viewfields.push({
          key: 'logincount',
          label: 'Total Login Count',
        })
        this.reportFieldsName['Total Login Count'] = 'logincount'
      }
      if (this.fields.length !== '0') {
        const data = {
          table_name: this.type,
          category: this.category,
          subcategory: this.subcategories,
          fields: this.fields,
        }

        const filter = {
          page: 1,
          limit: 30,
          sort: 'sort_order',
          order: '-1',
        }
        this.getDynamicReportData({ filter, data })
          .then((resp) => {
            this.dynamicReportData = resp
            this.isLoading = false
            this.isreportgenerated = true
            // this.resetData()
            this.downloadData()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.reportError = getError.message
          })
      }
    },
    downloadData() {
      this.isLoading = true
      if (this.fields.length === 0) {
        this.showerror = true
        this.isLoading = false
      } else {
        this.showerror = false
      }
      this.getFields()
      if (this.fields.includes('totalview')) {
        if (this.type === 'Event') {
          this.fields.push({ days: this.days })
          this.viewfields.push({
            key: 'totalview',
            label: 'Total Event Views',
          })
          this.reportFieldsName['Total Event Views'] = 'totalview'
        } else {
          this.fields.push({ days: this.days })
          this.viewfields.push({
            key: 'totalview',
            label: 'Total Course Views',
          })
          this.reportFieldsName['Total Course Views'] = 'totalview'
        }
      } else if (this.fields.includes('logincount')) {
        this.fields.push({ days: this.days })
        this.viewfields.push({
          key: 'logincount',
          label: 'Total Login Count',
        })
        this.reportFieldsName['Total Login Count'] = 'logincount'
      }
      if (this.fields.length !== '0') {
        const data = {
          table_name: this.type,
          category: this.category,
          subcategory: this.subcategories,
          fields: this.fields,
        }

        const filter = {
          page: 1,
          limit: 3000,
          sort: 'sort_order',
          order: '-1',
        }
        this.getDynamicReportData({ filter, data })
          .then((resp) => {
            this.downloadReportData = resp.docs
            this.isLoading = false
            this.isreportgenerated = true
            // this.resetData()
            // this.downloadData()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.reportError = getError.message
          })
      }
    },
    getFields() {
      let i = 0
      for (i = 0; i < this.fields.length; i++) {
        if (this.type === 'Course') {
          this.reportFieldsName['Course Name'] = 'name'
          this.viewfields.push({
            key: 'name',
            label: 'Course Name',
          })
          if (this.fields.includes('userinprogress')) {
            this.viewfields.push({
              key: 'totaluserinprogress',
              label: 'Total Users in Progress',
            })
            this.reportFieldsName['Total Users in Progress'] =
              'totaluserinprogress'
          }
          if (this.fields.includes('usercompleted')) {
            this.viewfields.push({
              key: 'totalusercompleted',
              label: 'Total Users Completed',
            })
            this.reportFieldsName['Total Users Completed'] =
              'totalusercompleted'
          }
          if (this.fields.includes('avgrating')) {
            this.viewfields.push({
              key: 'avg_rating',
              label: 'Average Rating',
            })
            this.reportFieldsName['Average Rating'] = 'avg_rating'
          }
        } else if (this.type === 'Event') {
          this.reportFieldsName['Event Name'] = 'name'
          this.viewfields.push({
            key: 'name',
            label: 'Event Name',
          })
          if (this.fields.includes('usersubscribed')) {
            this.viewfields.push({
              key: 'totalsubscribes',
              label: 'Total Event Subscribes',
            })
            this.reportFieldsName['Total Event Subscribed'] = 'totalsubscribes'
          }
          if (this.fields.includes('userunsubscribed')) {
            this.viewfields.push({
              key: 'totalunsubscribes',
              label: 'Total Event Unsubscribes',
            })
            this.reportFieldsName['Total Event Unsubscribed'] =
              'totalunsubscribes'
          }
        } else if (this.type === 'User') {
          this.reportFieldsName['User Name'] = 'name'
          this.viewfields.push({
            key: 'name',
            label: 'User Name',
          })
          if (this.fields.includes('courseinprogress')) {
            this.viewfields.push({
              key: 'courseinprogress',
              label: 'Course In Progress',
            })
            this.reportFieldsName['Course In Progress'] = 'courseinprogress'
          }
          if (this.fields.includes('coursecompleted')) {
            this.viewfields.push({
              key: 'coursecompleted',
              label: 'Course Completed',
            })
            this.reportFieldsName['Course Completed'] = 'coursecompleted'
          }
          if (this.fields.includes('eventsubscribed')) {
            this.viewfields.push({
              key: 'eventsubscribed',
              label: 'Event Subscribed',
            })
            this.reportFieldsName['Event Subscribed'] = 'eventsubscribed'
          }
        }
      }
    },
    resetData() {
      this.category = null
      this.fields = []
      this.tables = []
    },
    selectCategory() {
      this.show = true
      this.categoryName = this.getCategoryName()
      this.fetchSubCategoryList({ category: this.category }).then((sub) => {
        this.show = false
      })
    },

    getSubCategoryId(id) {
      if (this.subcategories.includes(id)) {
        this.subcategories.pop(id)
      } else {
        this.subcategories.push(id)
      }
    },
    getCategoryName() {
      var cate = this.categoryList().filter((item) => {
        return item._id === this.category
      })

      return cate[0].name
    },

    getReportFields() {
      this.reportFields = []
      this.subcategories = []
      this.fields = []
      this.getReportField(this.type).then((data) => {
        this.reportFields = data.docs[0].fields
        this.tables = data.docs[0].associated_tables
      })
    },
    formatDates(date) {
      return formatDate(date)
    },
  },
}
</script>
<template>
  <Layout>
    <b-card>
      <b-overlay
        v-if="!isreportgenerated"
        :show="isLoading"
        :opacity="0.6"
        rounded="sm"
      >
        <b-form @submit.prevent="dynamicReport"
          ><br />
          <b-alert
            v-model="isReportError"
            variant="danger"
            v-html="reportError"
          ></b-alert>
          <b-alert
            v-model="isSuccess"
            variant="success"
            v-html="reportSuccess"
          ></b-alert>
          <h5 v-if="showerror" class="alert alert-danger"
            >Please select fields.</h5
          >
          Report:
          <b-form-group>
            <b-form-select
              v-model="type"
              parsley-trigger="change"
              required
              @change="getReportFields"
            >
              <b-select-option :value="null" disabled
                >Select Report Type</b-select-option
              >
              <b-select-option
                v-for="(index, k) in reportTableList()"
                :key="k"
                :value="index.table_name"
                >{{ index.table_name }}</b-select-option
              >
            </b-form-select>
          </b-form-group>
          <b-form-group
            v-if="
              type !== null &&
                type !== 'User' &&
                (allSubCategoryList() && allSubCategoryList().length !== '0')
            "
          >
            Select SubCategory:
            <b-form-checkbox-group
              v-for="(i, k) in allSubCategoryList()"
              :key="k"
              v-model="subcategories"
              :options="[i.name]"
              @change="getSubCategoryId(i._id)"
            ></b-form-checkbox-group>
          </b-form-group>
          <b-form-group v-if="type !== null" label="Select Fields">
            <b-form-checkbox-group
              v-for="(i, k) in reportFields"
              :key="k"
              v-model="fields"
              :value="[i.field]"
              :options="[i]"
            ></b-form-checkbox-group>
          </b-form-group>
          <div
            v-if="fields.includes('totalview') || fields.includes('logincount')"
            >No. of Days:
            <b-form-input
              v-model="days"
              placeholder="Enter days"
              class="col-md-2 days"
            ></b-form-input>
          </div>

          <b-form-group id="button-group" class="mt-2">
            <b-button type="submit" variant="primary" class="btn-block button"
              >Submit</b-button
            >
          </b-form-group>
        </b-form>
      </b-overlay>
      <div v-if="isreportgenerated" class="row">
        <div class="col-md-12">
          <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
            <b-card v-if="dynamicReportData">
              <PlainTable
                :items="dynamicReportData ? dynamicReportData.docs : []"
                :fields="viewfields"
                :bordered="true"
                :per-page="dynamicReportData.limit"
                :total-rows="dynamicReportData.totalDocs"
                :current-page="1"
                :total-page="1"
                :paging-counter="dynamicReportData.pagingCounter"
              ></PlainTable>
              <b-button v-if="type === 'User'" class="downloadbtn">
                <download-excel
                  :data="downloadReportData"
                  :fields="reportFieldsName"
                  type="csv"
                  :name="type + ' ' + formatDates(new Date()) + '.csv'"
                >
                  Download to view all Users
                </download-excel>
              </b-button>
              <b-button v-else class="downloadbtn">
                <download-excel
                  :data="downloadReportData"
                  :fields="reportFieldsName"
                  type="csv"
                  :name="type + ' ' + formatDates(new Date()) + '.csv'"
                >
                  Download Report
                </download-excel>
              </b-button>
            </b-card>
          </b-overlay>
        </div>
      </div>
    </b-card>
  </Layout>
</template>
<style>
.button {
  width: 100px;
  background-color: skyblue;
}
.modal-backdrop {
  opacity: 0.5;
}
.days {
  display: flex;
}
.downloadbtn {
  margin: auto;
}
</style>
